import { MarketValueSource } from "../types/ownerDashboard.types";

export const MARKET_VALUE_YIELD_TOOLTIP_TITLE = "Base do valor de mercado";

export const MARKET_VALUE_YIELD_INFO_LABEL =
  "Como o rendimento sobre valor de mercado é calculado";

export function getMarketValueYieldTooltipDescription(
  source?: MarketValueSource | null
): string {
  if (source === "informed") {
    return "O rendimento usa o valor de mercado cadastrado por você no imóvel. Esse valor é opcional e útil, por exemplo, em aquisições por leilão.";
  }

  if (source === "fipe_estimate") {
    return "Nenhum valor de mercado foi cadastrado. O rendimento usa a estimativa FIPE Zap a partir do valor de aquisição, como antes.";
  }

  return "Com valor de mercado cadastrado, o rendimento usa esse valor. Sem cadastro, usa a estimativa FIPE Zap a partir da aquisição — o mesmo comportamento de antes.";
}

export function getMarketValueSourceHint(
  source: MarketValueSource | null | undefined
): string | null {
  if (source === "fipe_estimate") {
    return "Usando estimativa FIPE";
  }

  if (source === "informed") {
    return "Valor de mercado cadastrado";
  }

  return null;
}
